module.exports = __webpack_public_path__ + "695ac016f169614fea21c104de03221d.svg";